import { render, staticRenderFns } from "./vgt-grid.vue?vue&type=template&id=0c578fea&"
import script from "./vgt-grid.vue?vue&type=script&lang=js&"
export * from "./vgt-grid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports